import capitalize from 'lodash/capitalize'
import { t } from '../../i18n'
import { OrderProvider } from './types'

const scope = 'orders'

export const externalIdLabel = (
  orderProviders: OrderProvider[]
): string | null => {
  if (!orderProviders || orderProviders.length === 0) return null
  if (orderProviders.length === 1) {
    return t('provider_external_id', {
      scope,
      provider: capitalize(orderProviders[0].provider_type)
    })
  }
  return t('external_id', { scope })
}
